// extracted by mini-css-extract-plugin
export default {"editTaskModal_content":"TableAction_editTaskModal_content__UXYDb"};